var map = {
	"./meta.json": "e57c",
	"./views/contacts.json": "e4d9",
	"./views/e-appeal.json": "1d10",
	"./views/home.json": "19ff",
	"./views/news.json": "636b",
	"./views/projects.json": "30b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79b5";